/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router-dom';
import StreamingDevice from '../../../../components/Web/Addons/redesign/StreamingDevice';
import * as streamingDeviceActions from '../../actions';
import * as cartActions from '../../../../services/Cart/actions';
import * as loaderActions from '../../../../components/common/Loader/action';
import { getPlansData } from '../../../../utils/plansReference';
import * as taggingActions from '../../../Common/Tagging.js/actions';
import taggingSaga from '../../../Common/Tagging.js/sagas';
// import injectSaga from '../../../utils/injectSaga';
import injectSaga from '../../../../utils/injectSaga';
// import saga from '../sagas';
// import streamingDeviceReducer from '../reducer';
// import * as BaseSelectors from '../selectors/basetemplateSelectors';

const mapStateToProps = (state) => {
  const addonsData = state.addons || {};
  const mapAddonsWithType = (addons, type) => addons?.map((object) => ({ ...object, type })) || [];
  const streamingService = mapAddonsWithType(addonsData.streamingServices, 'streamingService');
  const streamingDevice = mapAddonsWithType(addonsData.accessoryDetails, 'streamingDevice');
  const accessoryDetails = streamingService && streamingDevice && [...streamingService, ...streamingDevice];
  const plansReferenceData = getPlansData(state.plansReferenceData);
  const loader = state.loader ? state.loader : {};
  const cartDetails = state.cartDetails ? state.cartDetails.cartDetailsJson : {};
  const showAddNotification = addonsData && addonsData.showAddNotification;
  const selectedProdID = addonsData && addonsData.selectedProdID;
  const addonObj = addonsData && addonsData.addonObj && addonsData.addonObj.oddOnListArr;
  const addOnLoadingDone = state?.cartDetails?.loadingDone;
  const skipBtnCall = addonsData && addonsData.skipBtnCall;
  return {
    accessoryDetails,
    plansReferenceData,
    loader,
    cartDetails,
    showAddNotification,
    selectedProdID,
    addonObj,
    addOnLoadingDone,
    skipBtnCall,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...streamingDeviceActions, ...cartActions, ...loaderActions, ...taggingActions }, dispatch);
}
const withConnect = connect(mapStateToProps, mapDispatchToProps);

// const withSaga = injectSaga({ key: 'StreamingDevice', saga });
const withSaga = compose(injectSaga({ key: 'taggingDetails', saga: taggingSaga }));
export default withRouter(
  compose(
    withSaga,
    // withReducer,
    withConnect,
  )(StreamingDevice),
);
